import React, { useRef } from 'react';

import { Box, Grid, ScrollBox, Text } from '~/components/blocks';
import { QuestionnaireSheet } from '~/components/partials';
import { NoAppointmentPrescriptionCollapse } from '~/components/partials/PatientDetailDialog/PatientPane/LineVisitorKarte/NoAppointmentPrescriptionCollapse';
import { PrescriptionCollapse } from '~/components/partials/PrescriptionCollapse';
import { LineVisitorDetailDialogProfileFragment } from '~/graphql/generated/graphql';
import { theme } from '~/styles/theme';

import { PatientProfile } from '../PatientProfile';

type Props = {
  visitor: LineVisitorDetailDialogProfileFragment;
};

export const LineVisitorKarte = React.memo((props: Props) => {
  const { visitor } = props;
  const scrollRef = useRef<RefAttributeType<typeof ScrollBox> | null>(null);
  const appointment = visitor.appointments.nodes[0] || null;
  const outpatientQuestionnaireEntry = visitor.outpatientQuestionnaireEntries.nodes[0] || null;
  const enteredAt = outpatientQuestionnaireEntry?.enteredAt;
  const start = appointment?.start;
  const isAppointmentLatest = !enteredAt || (start && start > enteredAt);
  const visitedAt =
    enteredAt && start ? (enteredAt > start ? enteredAt : start) : enteredAt || start || undefined;

  return (
    <Grid height="100%" overflow="auto" gridTemplateRows="min-content min-content 1fr">
      <PatientProfile patient={visitor} visitedAt={visitedAt} />
      <Box marginTop={theme.space.m}>
        {appointment && isAppointmentLatest ? (
          <PrescriptionCollapse appointmentId={appointment.id} />
        ) : (
          <NoAppointmentPrescriptionCollapse />
        )}
      </Box>
      <ScrollBox ref={scrollRef}>
        <Box marginTop={theme.space.l}>
          <Text fontWeight="bold" marginBottom={theme.space.m}>
            問診
          </Text>
          <QuestionnaireSheet loading={false} sheet={visitor.lineVisitorSheet ?? undefined} />
        </Box>
      </ScrollBox>
    </Grid>
  );
});

LineVisitorKarte.displayName = 'LineVisitorKarte';
